import React, {useState} from 'react'
import './ContestMenu.css';
import ContestMenu01 from "../../../static/img/Contest/crown.svg";
import ContestMenu01Yellow from "../../../static/img/Contest/crownYellow.svg";
import ContestMenu02 from "../../../static/img/Contest/cup.svg";
import ContestMenu02Yellow from "../../../static/img/Contest/cupYellow.svg";
import ContestMenu03 from "../../../static/img/Contest/medal.svg";
import ArrowUpHover from "../../../static/img/Contest/ArrowUpHover.svg";
import ContestMenu03Yellow from "../../../static/img/Contest/medalYellow.svg";
import ChangeLink from "../../../Elements/ChangeLink/ChangeLink";

function ContestMenu(props){
    const [OpenStatus, setOpenStatus] = useState(false);

    function OpenMenu() {setOpenStatus(!OpenStatus);}

        return (
            <div className={"ContestMenu " + (OpenStatus ? 'ContestMenuOpen' : 'ContestMenuClose')}>
                <ChangeLink lang={props.lang} to='/contests/join/championship'  className={props.MenuElements[0]}>
                    <div className="ContestMenuElement" role = "button" tabIndex={0} onClick={() => OpenMenu()}>
                        <img src={ContestMenu01}  alt='Ifyoudontseeimages' width='52px'/>
                        <img src={ContestMenu01Yellow}  alt='Ifyoudontseeimages' width='52px'  className="ContestMenuElementIMGYellow"/>
                        <div className="ContestMenuElementText">Newbie Championship</div>
                        <img src={ArrowUpHover}  alt='Ifyoudontseeimages' width='22px' className="ArrowUpHover"/>

                    </div>
                </ChangeLink>
                <ChangeLink lang={props.lang} to='/contests/all-history' className={props.MenuElements[1]}>
                    <div className="ContestMenuElement" role = "button" tabIndex={0} onClick={() => OpenMenu()}>
                        <img src={ContestMenu02}  alt='Ifyoudontseeimages' width='52px'/>
                        <img src={ContestMenu02Yellow}  alt='Ifyoudontseeimages' width='52px' className="ContestMenuElementIMGYellow"/>
                        <div className="ContestMenuElementText">Old Contests</div>
                        <img src={ArrowUpHover}  alt='Ifyoudontseeimages' width='22px' className="ArrowUpHover"/>

                    </div>
                </ChangeLink>
                <ChangeLink lang={props.lang} to='/contests/prize' className={props.MenuElements[2]}>
                    <div className="ContestMenuElement" role = "button" tabIndex={0} onClick={() => OpenMenu()}>
                        <img src={ContestMenu03}  alt='Ifyoudontseeimages' width='52px'/>
                        <img src={ContestMenu03Yellow}  alt='Ifyoudontseeimages' width='52px' className="ContestMenuElementIMGYellow"/>
                        <div className="ContestMenuElementText">Get the Prize</div>
                        <img src={ArrowUpHover}  alt='Ifyoudontseeimages' width='22px' className="ArrowUpHover"/>

                    </div>
                </ChangeLink>
            </div>
)}
export default ContestMenu




